<web-settings-breadcrumbs>
    <div class="breadcrumb-icon">
        <a [tooltip]="'site_styles' | translate" placement="bottom" (click)="setSelectedTheme()">
            <img
                src="./assets/img/websites/lpc-theme-settings-icon.svg"
                class="first-breadcrumb-icon"
                alt="theme-settings"
            />
        </a>
        <img
            src="assets/img/websites/lpc-breadcrumb-arrow-icon.svg"
            class="breadcrumb-arrow-icon"
            alt="breadcrumb-arrow"
        />
    </div>

    @if (hideBreadcrumbs()) {
        <div class="breadcrumb-icon">
            <a
                [tooltip]="'control_block' | translate"
                placement="bottom"
                (click)="setSelectedZeroBlock(section().parentId)"
            >
                <img src="./assets/img/websites/lpc-block-icon.svg" class="first-breadcrumb-icon" alt="block-icon" />
            </a>
            <img
                src="./assets/img/websites/lpc-breadcrumb-arrow-icon.svg"
                class="breadcrumb-arrow-icon"
                alt="breadcrumb-arrow"
            />
        </div>
    } @else {
        @if (section(); as section) {
            @if (isInSpecificSection()) {
                <div class="breadcrumb-icon">
                    <a
                        [tooltip]="'category_header' | translate"
                        placement="bottom"
                        (click)="setSelectedSpecificBlock(section.parentId)"
                    >
                        <img
                            src="./assets/img/websites/lpc-icon-header.svg"
                            class="first-breadcrumb-icon"
                            alt="block-icon"
                        />
                    </a>
                    <img
                        src="./assets/img/websites/lpc-breadcrumb-arrow-icon.svg"
                        class="breadcrumb-arrow-icon"
                        alt="breadcrumb-arrow"
                    />
                </div>

                <div class="breadcrumb-icon">
                    <a
                        [tooltip]="'row' | translate"
                        placement="bottom"
                        (click)="setSelectedSpecificSection(section.id)"
                    >
                        <img
                            src="./assets/img/websites/lpc-icon-row.svg"
                            class="first-breadcrumb-icon"
                            alt="column-icon"
                        />
                    </a>
                    <img
                        src="./assets/img/websites/lpc-breadcrumb-arrow-icon.svg"
                        class="breadcrumb-arrow-icon"
                        alt="breadcrumb-arrow"
                    />
                </div>
            } @else {
                <div class="breadcrumb-icon">
                    <a
                        [tooltip]="'control_block' | translate"
                        placement="bottom"
                        (click)="setSelectedBlock(section.parentId)"
                    >
                        <img
                            src="./assets/img/websites/lpc-block-icon.svg"
                            class="first-breadcrumb-icon"
                            alt="block-icon"
                        />
                    </a>
                    <img
                        src="./assets/img/websites/lpc-breadcrumb-arrow-icon.svg"
                        class="breadcrumb-arrow-icon"
                        alt="breadcrumb-arrow"
                    />
                </div>
            }
        }

        @if (!isInSpecificSection() && column()) {
            <div class="breadcrumb-icon">
                <a
                    [tooltip]="'control_column' | translate"
                    placement="bottom"
                    (click)="setSelectedColumn(column()?.id)"
                >
                    <img
                        src="./assets/img/websites/lpc-column-icon.svg"
                        class="first-breadcrumb-icon"
                        alt="column-icon"
                    />
                </a>
                <img
                    src="./assets/img/websites/lpc-breadcrumb-arrow-icon.svg"
                    class="breadcrumb-arrow-icon"
                    alt="breadcrumb-arrow"
                />
            </div>
        }

        <!--  TODO: icon for structure   -->
        @if (!isInSpecificSection() && gridId()) {
            <div class="breadcrumb-icon">
                <a [tooltip]="'Structure' | translate" placement="bottom" (click)="setSelectedGrid(gridId())">
                    <img
                        src="./assets/img/websites/lpc-structure-icon.svg"
                        class="first-breadcrumb-icon"
                        alt="column-icon"
                    />
                </a>
                <img
                    src="./assets/img/websites/lpc-breadcrumb-arrow-icon.svg"
                    class="breadcrumb-arrow-icon"
                    alt="breadcrumb-arrow"
                />
            </div>
        }
    }

    <div class="breadcrumb-icon">
        <img
            src="./assets/img/websites/lpc-{{ widgetName() }}-icon.svg"
            class="first-breadcrumb-icon"
            alt="widget-icon"
        />
    </div>
    <div class="breadcrumb-text clip-text" [class.short]="gridId()" [title]="widgetLabel() | translate">
        <span>{{ widgetLabel() | translate }}</span>
    </div>
</web-settings-breadcrumbs>

@if (knowledgeBaseLink(); as knowledgeBaseLink) {
    <a [href]="knowledgeBaseLink | translate" class="kb-link" target="_blank">
        <span class="small sp-icon icon-info"> </span> {{ "knowledge_base_widget_tooltip" | translate }}
        <span class="color-light small sp-icon icon-outgoing"> </span>
    </a>
}
